import { CheckCircleOutlined } from '@ant-design/icons';
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import _ from 'lodash';

// Import React Table
import ReactTable from 'react-table';
import 'react-table/react-table.css';

import { ReportsDataStore } from 'stores';

const NoIssuesSection = styled.div`
  display: flex;
  align-items: center;
  p {
    margin-bottom: 0px;
    font-size: 14px;
  }
  i {
    font-size: 36px;
    margin-right: 12px;
  }
`;

const ReactTableStyled = styled(ReactTable)`
  text-align: center;
  maragin-top: 20px;
`;

class IdlingTimeTable extends Component {
  render() {
    if (_.isEmpty(ReportsDataStore.alarmReport.data)) {
      return (
        <NoIssuesSection>
          <CheckCircleOutlined />
          <p>Your fleet has no Driving data!</p>
        </NoIssuesSection>
      );
    }

    return (
      <div style={{ marginTop: '20px' }}>
        <ReactTableStyled
          columns={[
            {
              Header: 'Vehicle',
              id: 'car.make_model_year',
              accessor: (data) => {
                return (
                  <div>
                    <Link to={'/car/' + data.id_car}>
                      <span>
                        {data.car_make} {data.car_model} {data.car_year}
                      </span>
                    </Link>
                  </div>
                );
              },
            },
            {
              Header: 'Idling Time (Minutes)',
              id: 'car.idling_sum',
              accessor: 'idling_sum',
              Cell: (data) => {
                let idlingTime = data.original.idling_sum / 60;
                idlingTime = Math.round(idlingTime);
                return <span>{idlingTime}</span>;
              },
            },
          ]}
          // manual // Forces table not to paginate or sort automatically, so we can handle it server-side
          data={ReportsDataStore.alarmReport.data}
          pages={Math.round(ReportsDataStore.alarmReport.data.length / 5)} // Display the total number of pages
          loading={ReportsDataStore.alarmReport.pending} // Display the loading overlay when we need it
          defaultPageSize={5}
          sortable={true}
          defaultSorted={[
            {
              id: 'car.idling_sum',
              desc: true,
            },
          ]}
          className="-highlight smallTable"
        />
      </div>
    );
  }
}

export default observer(IdlingTimeTable);
